"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupReservationId = exports.CameraSubjectResponseId = exports.CameraSubjectRequestId = exports.CatalogItemId = exports.AnchorRequestId = exports.ScanningRequestId = exports.PresentationId = exports.ElementId = exports.AnchorId = exports.ElementGroupId = exports.SessionId = exports.CognitoUserId = exports.UserId = exports.FeedbackId = exports.DetectionId = exports.NoteId = exports.MeshId = exports.RoomOutcomeReportId = exports.BookmarkId = exports.GpsId = exports.RecordingTrackId = exports.RecordingId = exports.StreemshotRequestId = exports.StreemshotRevisionId = exports.StreemshotId = exports.LoginIdentityId = exports.AnonymousUserId = exports.RoomInvitationId = exports.RoomId = exports.InvitationId = exports.GPSRequestId = exports.GroupId = exports.EntityEventId = exports.DeviceId = exports.CompanyId = exports.CapabilitiesId = exports.AppId = exports.ApiCredentialId = void 0;
const domain_id_1 = require("./domain_id");
/**
 * These are helper classes that simplify DomainId generator for well known types.
 */
class ApiCredentialId extends domain_id_1.DomainId {
    constructor(sid) {
        super('api', sid);
    }
}
exports.ApiCredentialId = ApiCredentialId;
class AppId extends domain_id_1.DomainId {
    constructor(sid) {
        super('app', sid);
    }
}
exports.AppId = AppId;
class CapabilitiesId extends domain_id_1.DomainId {
    constructor(sid) {
        super('consum', sid);
    }
}
exports.CapabilitiesId = CapabilitiesId;
class CompanyId extends domain_id_1.DomainId {
    constructor(sid) {
        super('co', sid);
    }
}
exports.CompanyId = CompanyId;
class DeviceId extends domain_id_1.DomainId {
    constructor(sid) {
        super('dvc', sid);
    }
}
exports.DeviceId = DeviceId;
class EntityEventId extends domain_id_1.DomainId {
    constructor(sid) {
        super('event', sid);
    }
}
exports.EntityEventId = EntityEventId;
class GroupId extends domain_id_1.DomainId {
    constructor(sid) {
        super('grp', sid);
    }
}
exports.GroupId = GroupId;
class GPSRequestId extends domain_id_1.DomainId {
    constructor(sid) {
        super('gpr', sid);
    }
}
exports.GPSRequestId = GPSRequestId;
class InvitationId extends domain_id_1.DomainId {
    constructor(sid) {
        super('uinv', sid);
    }
}
exports.InvitationId = InvitationId;
class RoomId extends domain_id_1.DomainId {
    constructor(sid) {
        super('rm', sid);
    }
}
exports.RoomId = RoomId;
class RoomInvitationId extends domain_id_1.DomainId {
    constructor(sid) {
        super('inv', sid);
    }
}
exports.RoomInvitationId = RoomInvitationId;
class AnonymousUserId extends domain_id_1.DomainId {
    constructor(sid) {
        super('anon', sid);
    }
}
exports.AnonymousUserId = AnonymousUserId;
class LoginIdentityId extends domain_id_1.DomainId {
    constructor(sid) {
        super('lid', sid);
    }
}
exports.LoginIdentityId = LoginIdentityId;
class StreemshotId extends domain_id_1.DomainId {
    constructor(sid) {
        super('ss', sid);
    }
}
exports.StreemshotId = StreemshotId;
class StreemshotRevisionId extends domain_id_1.DomainId {
    constructor(sid) {
        super('ssrev', sid);
    }
}
exports.StreemshotRevisionId = StreemshotRevisionId;
class StreemshotRequestId extends domain_id_1.DomainId {
    constructor(sid) {
        super('ssr', sid);
    }
}
exports.StreemshotRequestId = StreemshotRequestId;
class RecordingId extends domain_id_1.DomainId {
    constructor(sid) {
        super('rec', sid);
    }
}
exports.RecordingId = RecordingId;
class RecordingTrackId extends domain_id_1.DomainId {
    constructor(sid) {
        super('tr', sid);
    }
}
exports.RecordingTrackId = RecordingTrackId;
class GpsId extends domain_id_1.DomainId {
    constructor(sid) {
        super('gps', sid);
    }
}
exports.GpsId = GpsId;
class BookmarkId extends domain_id_1.DomainId {
    constructor(sid) {
        super('bm', sid);
    }
}
exports.BookmarkId = BookmarkId;
class RoomOutcomeReportId extends domain_id_1.DomainId {
    constructor(sid) {
        super('ror', sid);
    }
}
exports.RoomOutcomeReportId = RoomOutcomeReportId;
class MeshId extends domain_id_1.DomainId {
    constructor(sid) {
        super('mesh', sid);
    }
}
exports.MeshId = MeshId;
class NoteId extends domain_id_1.DomainId {
    constructor(sid) {
        super('nt', sid);
    }
}
exports.NoteId = NoteId;
class DetectionId extends domain_id_1.DomainId {
    constructor(sid) {
        super('det', sid);
    }
}
exports.DetectionId = DetectionId;
class FeedbackId extends domain_id_1.DomainId {
    constructor(sid) {
        super('feed', sid);
    }
}
exports.FeedbackId = FeedbackId;
class UserId extends domain_id_1.DomainId {
    constructor(sid) {
        super('usr', sid);
    }
}
exports.UserId = UserId;
class CognitoUserId extends domain_id_1.DomainId {
    constructor(sid) {
        super('cusr', sid);
    }
}
exports.CognitoUserId = CognitoUserId;
class SessionId extends domain_id_1.DomainId {
    constructor(sid) {
        super('sesh', sid);
    }
}
exports.SessionId = SessionId;
/* AR Elements */
class ElementGroupId extends domain_id_1.DomainId {
    constructor(sid) {
        super('elg', sid);
    }
}
exports.ElementGroupId = ElementGroupId;
class AnchorId extends domain_id_1.DomainId {
    constructor(sid) {
        super('anc', sid);
    }
}
exports.AnchorId = AnchorId;
class ElementId extends domain_id_1.DomainId {
    constructor(sid) {
        super('ele', sid);
    }
}
exports.ElementId = ElementId;
class PresentationId extends domain_id_1.DomainId {
    constructor(sid) {
        super('pres', sid);
    }
}
exports.PresentationId = PresentationId;
class ScanningRequestId extends domain_id_1.DomainId {
    constructor(sid) {
        super('arsr', sid);
    }
}
exports.ScanningRequestId = ScanningRequestId;
class AnchorRequestId extends domain_id_1.DomainId {
    constructor(sid) {
        super('arar', sid);
    }
}
exports.AnchorRequestId = AnchorRequestId;
class CatalogItemId extends domain_id_1.DomainId {
    constructor(sid) {
        super('cat', sid);
    }
}
exports.CatalogItemId = CatalogItemId;
class CameraSubjectRequestId extends domain_id_1.DomainId {
    constructor(sid) {
        super('cam', sid);
    }
}
exports.CameraSubjectRequestId = CameraSubjectRequestId;
class CameraSubjectResponseId extends domain_id_1.DomainId {
    constructor(sid) {
        super('csrr', sid);
    }
}
exports.CameraSubjectResponseId = CameraSubjectResponseId;
class GroupReservationId extends domain_id_1.DomainId {
    constructor(sid) {
        super('rsv', sid);
    }
}
exports.GroupReservationId = GroupReservationId;
//# sourceMappingURL=domain_id.well-known.js.map